import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';
import 'highcharts';

import {
  CONVERSION_STATUS_TYPE,
} from '@bingads-webui-campaign/recommendation-core';

import template from '../template/chart.pug';
import uetLinkTemplate from '../template/uet-link.pug';
import { initChart } from './chart-config';
import { COLUMNS_METRICS } from './const';

export class BudgetLandScapeChart extends Backbone.View {
  initialize({
    tableViewmodel,
    i18n,
    conversionSummaryStatus,
    legacyRouter,
  }) {
    this.tableViewmodel = tableViewmodel;
    this.i18n = i18n;
    this.conversionSummaryStatus = conversionSummaryStatus;
    this.legacyRouter = legacyRouter;
  }

  get events() {
    return {
      'click .uet-link': 'goToUET',
    };
  }

  goToUET() {
    this.legacyRouter.navigateToRoute('uettag');
    this.trigger('close_poputil');
  }

  render() {
    this.$el.html(template({
      i18n: this.i18n,
      noUET: this.conversionSummaryStatus === CONVERSION_STATUS_TYPE.NO_UET,
      noData: this.conversionSummaryStatus === CONVERSION_STATUS_TYPE.NO_DATA,
      uetLink: uetLinkTemplate({ i18n: this.i18n }),
    }));
    ko.applyBindings(this.tableViewmodel, this.el);

    // delay draw graph when view is rendered on page, otherwise chart width doesn't respect parent.
    _.defer(() => {
      this.redraw();
    });
    return this;
  }

  onPointClicked(e, x) {
    this.tableViewmodel.selectedRowIndex(x);
  }

  redraw() {
    const selectedColumnIndex = this.tableViewmodel.selectedColumnIndex();
    const isBudgetColumnSelected = selectedColumnIndex === 0;

    const estimations = this.tableViewmodel.estimationKPIArray();
    const budgetPoint = _.isEmpty(estimations) ? 0 : this.tableViewmodel.inputBudget();
    const selectedEstimationPoint = selectedColumnIndex === 0
      ? budgetPoint : (estimations[selectedColumnIndex - 1] || 0);

    const budgetPoints =
      _.pluck(this.tableViewmodel.landscapes, COLUMNS_METRICS.budget)
        .concat(budgetPoint);
    const points =
      this.tableViewmodel.selectedColumnData()
        .concat(selectedEstimationPoint);

    this.$('.column-chart-container').highcharts(initChart({
      seriesName: this.tableViewmodel.chartTitle(),
      selectedRowIndex: this.tableViewmodel.selectedRowIndex(),
      budgetPoints,
      points,
      i18n: this.i18n,
      onPointClicked: this.onPointClicked.bind(this),
      isBudgetColumnSelected,
    }));
  }
}
